module.exports = __webpack_public_path__ + "img/2.438fb420.png";